import React, { createElement, FC, useState } from "react";
import { MenuItem } from "@constants/menu";
import { useTranslation } from "react-i18next";
import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Item from "@components/SideBar/Item";

const NestedMenuItem: FC<
  MenuItem & {
    compact: boolean;
    selectedItem: string | null;
    onNavigate?: () => void;
  }
> = ({ icon, title, id, children, compact, selectedItem, onNavigate }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      {!compact ? (
        <ListItem disableGutters={true}>
          <ListItemButton id={id} onClick={handleClick}>
            <ListItemIcon
              sx={{
                minWidth: "40px",
              }}
            >
              {createElement(icon)}
            </ListItemIcon>
            {!compact && (
              <ListItemText
                primary={t(title)}
                primaryTypographyProps={{ noWrap: true }}
              />
            )}

            <Box marginLeft="16px">
              {open ? <ExpandLess /> : <ExpandMore />}
            </Box>
          </ListItemButton>
        </ListItem>
      ) : (
        (children || []).map((item) => {
          return (
            <Item
              id={id}
              key={item.id || item.title}
              {...item}
              disableGutters={true}
              compact={true}
              selected={selectedItem === item.path}
              onNavigate={onNavigate}
            />
          );
        })
      )}

      <Collapse in={open && !compact} timeout="auto" unmountOnExit>
        <List component="div">
          {children!.map((item) => {
            return (
              <Item
                key={item.id || item.title}
                {...item}
                disableGutters={false}
                compact={false}
                selected={selectedItem === item.path}
                onNavigate={onNavigate}
              />
            );
          })}
        </List>
      </Collapse>
    </>
  );
};

export default NestedMenuItem;
